<template>
  <div class="home">
      <banner></banner>
      <div class="contentBox1">
          <p class="contentBox1_mainTitle" ref="mainTitle">{{$t('Protection').toUpperCase()}}</p>
          <p class="contentBox1_mainText">{{$t('ProtectionText')}}</p>
          <el-row class="homeFade" :gutter="10">
            <el-col :xs="24" :sm="24" :md="{span:6,offset:3}">
              <transition name="fade">
                <slideInUp v-if="slideInUp1" :textMini="$t('textMini1')" type="clothes" number="15000" :postfix="$t('件')" url="contentBox1_info_img1"></slideInUp>          
              </transition>  
            </el-col>
            <el-col :xs="24" :sm="24" :md="6">
              <transition name="fade">
                <slideInUp v-if="slideInUp2" :textMini="$t('textMini2')"  type="country" number="30" :postfix="$t('余个')" url="contentBox1_info_img2"></slideInUp>          
              </transition>       
            </el-col>
            <el-col :xs="24" :sm="24" :md="6">
              <transition name="fade">
                <slideInUp v-if="slideInUp3" :textMini="$t('textMini3')"  type="product" number="50" :postfix="$t('余种')" url="contentBox1_info_img3"></slideInUp>          
              </transition>                      
            </el-col>
          </el-row>
          <p class="contentBox1_mainTitle" ref="centerSlide">{{$t('Product').toUpperCase()}}</p>
          <div class="centerSlideBox">
            <transition name="fadeLeft">
              <div v-if="centerSlide" class="centerSlide1">
                <div class="leftCenterSlide leftCenterSlidePos">
                  <p class="title">{{$t('医疗防护用品')}}</p>
                  <p class="txt">{{$t('安全防护')}}</p>
                  <div class="more">
                        <div>{{$t('more')}}</div>               
                        <img src="../../public/img/whiteRight.png" alt="" srcset="">
                    </div>
                </div>
              </div>
            </transition>
            <transition name="fadeRight">
              <div v-if="centerSlide" class="centerSlide2">
                <div class="leftCenterSlide rightCenterSlidePos">
                  <p class="title">{{$t('日常防护用品')}}</p>
                  <p class="txt">{{$t('健康防护')}}</p>
                  <div class="more">
                        <div>{{$t('more')}}</div>
                        <img src="../../public/img/whiteRight.png" alt="" srcset="">
                    </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="news">
            <div class="newsContent">
              <p ref="newsContentText">{{$t('NewsCenter').toUpperCase()}}</p>
              <newsBannerPhone v-if="!isPC"></newsBannerPhone>
              <newsBannerPC v-if="isPC"></newsBannerPC>
              
              <transition name="fade">
                <h2 v-if="newsContentText">{{$t('保质保量')}}</h2>
              </transition>    
            </div>
          </div>
          <foot></foot>
      </div>
  </div>
</template>

<script>
import banner from "@/components/banner.vue";
import slideInUp from "@/components/slideInUp.vue";
import foot from "@/components/foot.vue";
import newsBannerPC from "@/components/newsBannerPC.vue";
import newsBannerPhone from "@/components/newsBannerPhone.vue";



import { constants } from 'zlib';
import { setTimeout } from 'timers';

export default {
  name: "Home",
  data() {
    return {
      timer:null,
      slideInUp1:false,
      slideInUp2:false,
      slideInUp3:false,
      centerSlide:false,
      newsContentText:false,
      winH:0,
      isPC:true
    }
  },
  components: {
    banner,slideInUp,foot,newsBannerPC,newsBannerPhone
  },
  methods:{
    listenScroll(){
        if(window.innerWidth<=800){
          this.isPC = false
        }else{
          this.isPC = true
        }
        let scroll = document.documentElement.scrollTop
        if((!this.slideInUp1)&&(!this.slideInUp2)&&(!this.slideInUp3) && this.$refs.mainTitle.getBoundingClientRect().top-this.winH<-300){
          this.slideInUp1 = true
          setTimeout(()=>{
            this.slideInUp2 = true
          },200)
          setTimeout(()=>{
            this.slideInUp3 = true
          },400)
        }
        if((!this.centerSlide)&& this.$refs.centerSlide.getBoundingClientRect().top-this.winH<-300){
          this.centerSlide = true
        }
        if(!this.newsContentText&&this.$refs.newsContentText.getBoundingClientRect().top-this.winH<0){
          this.newsContentText = true
        }
    }
  },
  mounted(){
    this.timer = setInterval(this.listenScroll,200)
    this.winH = document.documentElement.clientHeight || document.body.clientHeight
  },
  destroyed(){
    clearInterval(this.timer)
  }
};
</script>
<style lang="less" scope>
.home {
  .contentBox1 {
    width: 100vw;
    
    .news{
      width: 100vw;
      // height: 100vh;
      min-height: 100vh;
      font-size: 1rem;
      text-align: center;
      font-weight: bold;
      color: #747474;
      // font-family: "Microsoft YaHei UI";
      background-image: url('../../public/img/news.jpg');
      margin: 0;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
      .newsContent{
        z-index: 500;
        position: relative;
        margin: 0;
        min-height: 100%;
        width: 100%;
        padding: 1px;
        p{
          margin-top: 3rem;
          margin-bottom: 3rem;
          font-size: 1.6rem;
        }
        h2{
          color: #017CA4;
          font-weight: bold;
          display: block;
          width: 100vw;
          font-size: 3rem;
          margin: 5rem 0;
          margin-bottom: 7rem;
        }
      }
    }
    .news::before{
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-image: linear-gradient(rgba(255, 255, 255,1), rgba(255, 255, 255,0));
      z-index: 1;
    }
    .centerSlideBox{
      width: 100%;
      margin-bottom: 3rem;
      height: 80vh;
      background-color: rgb(255, 255, 255);
      .centerSlide1{
        width: 100%;
        height: 40vh;
        background-image: url('../../public/img/centerSlide1.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        background-position: center;
      }
      .centerSlide2{
        width: 100%;
        height: 40vh;
        padding: 1px;
        position: relative;
        background-image: url('../../public/img/centerSlide2.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }
      .leftCenterSlidePos{
        position: absolute;
        left: 20%;
        top: 50%;
        transform: translate(0,-50%);
        text-align: left;
        .more{
          float: left;          
          img{
            margin-left: 10px;
          }
        }
      }
      .rightCenterSlidePos{
        position: absolute;
        right: 20%;
        top: 50%;
        transform: translate(0,-50%);
        text-align: right;
        .more{
          float: right;
          img{
            margin-left: 10px;
          }
        }
      }
      .leftCenterSlide{
        height: 70%;
        .title{
          color: #fff;
          font-size: 1.5rem;
          font-weight: bold;
        }
        .txt{
          margin-top: -7%;
          font-size: 0.8rem;
          color: #fff;
        }
        .more{
          width: 5rem;
          height: 1.8rem;
          margin-top: 3%;
          border-radius: 1.5rem;
          border: #fff 1.5px solid;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.7rem;
          font-weight: bold;
          color: #fff;
          cursor: pointer;
          img{
              height: 40%;
          }
        }
      }
    }
    
    .contentBox1_mainTitle {
      font-size: 1.6rem;
      text-align: center;
      font-weight: bold;
      // font-family: "Microsoft YaHei UI";
      color: #747474;
      margin-top: 5rem;
      margin-bottom: 3rem;
    }
    .homeFade {
      margin-top: 2.5rem;
      min-height: 300px;
       .el-col {
        border-radius: 4px;
      }
    }
   
    .contentBox1_info{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      
    }
    .contentBox1_mainText {
      font-size: 0.8rem;
      text-align: center;
      max-width: 40rem;
      letter-spacing: 0.18rem;
      margin: 0 auto;
      color: #747474;
      // font-family: "Microsoft YaHei UI";
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .4s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translate(0,50%);
  }

  .fadeLeft-enter-active, .fadeLeft-leave-active {
    transition: all .4s;
  }
  .fadeLeft-enter, .fadeLeft-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translate(-100%,0);
  }
  .fadeRight-enter-active, .fadeRight-leave-active {
    transition: all .4s 0.4s;
  }
  .fadeRight-enter, .fadeRight-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translate(100%,0);
  }
}
</style>
<i18n>
{
  "en": {
      "textMini1":"Nissan medical protective clothing",
      "textMini2":"Product Covered Countries",
      "textMini3":"Product Category",
      "NewsCenter":"News",
      "Protection":"Protection",
      "ProtectionText":"Yucheng is a company committed to the production of various non-woven protective products, adhere to integrity-based, quality first.",
      "Product":"Product",
      "more":"MORE",
      "医疗防护用品":"Medical Protective Equipment",
      "安全防护":"Safety protection",
      "保质保量":"Quality and quantity, providing customers with wholehearted care",
      "件":"Pieces",               
      "余个":"Each",
      "余种":"Species",
      "日常防护用品":"Daily Protective Equipment",
      "健康防护":"Health protection, comfortable life"                                
  },
  "zh": {
       "textMini1":"医用防护服日产",
       "textMini2":"产品覆盖国家",
       "textMini3":"产品种类",
       "NewsCenter":"新闻中心",
       "Protection":"誉诚防护",
       "ProtectionText":"誉诚是一家致力于生产各类无纺布防护用品的公司，坚持诚信为本，质量第一。",
       "Product":"誉诚产品",
       "more":"更多",
       "医疗防护用品":"医疗防护用品",
       "安全防护":"安全防护 安心就医",
       "保质保量":"保质保量，为客户提供全身心的呵护",
       "件":"件",
       "余个":"余个",
       "余种":"余种",
       "日常防护用品":"日常防护用品",
       "健康防护":"健康防护 舒心生活"
  }
}
</i18n>

